
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContextMessageAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageBasicFields"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageUserContext"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageBoard"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageConversation"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subject"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContextMessageContentWorkflow"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageState"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"moderationData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rejectReason"},"arguments":[],"directives":[]}]}}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("../messages/MessageBasicFields.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageBoard.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageConversation.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageContentWorkflow.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../messages/MessageState.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ContextMessageUserContext.fragment.graphql").definitions));


    module.exports = doc
  
